<template>
  <el-select
    style="width: 100%"
    :size="size"
    filterable
    :remote="!usesMediaCoreRecommendations"
    :value="idDvrServer"
    :loading="loading && !recommendedServers.length"
    :remote-method="usesMediaCoreRecommendations ? null : remoteMethod"
    v-on="$listeners"
  >
    <el-option
      v-for="server in recommendedServers"
      :key="server.id"
      :label="server.name"
      :value="server.id"
    >
      <span class="left_info">{{ server.name }}</span>
      <span class="right_info">
        <span :class="server.classStreams">
          <fa :icon="['fas', 'exchange-alt']" />
          {{ server.freely_streams }}
        </span>
        <span :class="server.classArchive">
          <fa :icon="['fas', 'database']" />
          {{ server.freely_archive }}
        </span>
      </span>
    </el-option>
    <el-option
      v-if="!usesMediaCoreRecommendations && page * count < total"
      :value="0"
      disabled
      style="align-items: center; text-align: center"
    >
      <el-button
        :loading="loading && !queryLoading"
        type="text"
        style="width: 100%"
        size="mini"
        @click="nextPage"
      >
        {{ loading && !queryLoading ? "Загрузка" : "Показать еще" }}
      </el-button>
    </el-option>
  </el-select>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExchangeAlt, faDatabase } from "@fortawesome/free-solid-svg-icons";
import { ApiService } from "@/api";

library.add(faExchangeAlt, faDatabase);

export default {
  name: "DvrServersSelect",
  components: {
    fa,
  },
  model: {
    prop: "idDvrServer",
    event: "change",
  },
  props: {
    idDvrServer: {
      type: Number,
      default: null,
    },
    idMediaCore: {
      type: Number,
      default: null,
    },
    idProxyServer: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
    isForRrtsp: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      page: 1,
      count: 50,
      query: "",
      total: 0,
      queryLoading: false,
      loading: false,
      recommendedServers: [],
      requestId: 0,
    };
  },
  computed: {
    usesMediaCoreRecommendations() {
      return Number.isInteger(this.idMediaCore);
    },
  },
  watch: {
    idMediaCore: {
      immediate: true,
      handler() {
        this.resetAndPull();
      },
    },
    idProxyServer() {
      if (this.usesMediaCoreRecommendations) this.resetAndPull();
    },
  },
  methods: {
    clearData() {
      this.page = 1;
      this.total = 0;
    },
    resetAndPull() {
      this.clearData();
      this.recommendedServers = [];
      this.pullRecommendedDvrServers();
    },
    remoteMethod(query) {
      this.queryLoading = true;
      this.query = encodeURI(query);
      this.clearData();
      this.pullRecommendedDvrServers().finally(() => {
        this.queryLoading = false;
      });
    },
    nextPage() {
      this.page += 1;
      this.pullRecommendedDvrServers(true);
    },
    decorateServers(servers) {
      return servers.map((server) => ({
        ...server,
        classStreams: server.freely_streams <= 0 ? "color_alert" : "color_recommend",
        classArchive: server.freely_archive <= 0 ? "color_alert" : "color_recommend",
      }));
    },
    pullRecommendedDvrServers(append = false) {
      const requestId = ++this.requestId;
      this.loading = true;

      const request = this.usesMediaCoreRecommendations
        ? ApiService.servers.getDvrRecommendByMediaCore(this.idMediaCore, this.idProxyServer || "")
        : ApiService.servers.getRecommendPaginate({
            idDvrServer: this.idDvrServer || "",
            page: this.page,
            search: this.query,
            count: this.count,
            is_for_rrtsp: this.isForRrtsp,
          });

      return request
        .then((response) => {
          if (requestId !== this.requestId) return;

          const servers = this.usesMediaCoreRecommendations ? response : response.data;
          this.total = this.usesMediaCoreRecommendations ? servers.length : response.total;
          this.recommendedServers = this.decorateServers(
            append ? [...this.recommendedServers, ...servers] : servers
          );
        })
        .catch(() => {
          if (requestId !== this.requestId) return;
          this.total = 0;
          this.recommendedServers = [];
          this.$message.error("Не удалось загрузить список серверов");
        })
        .finally(() => {
          if (requestId === this.requestId) this.loading = false;
        });
    },
  },
};
</script>

<style>
.left_info {
  float: left;
  padding-right: 5px;
}
.right_info {
  float: right;
  text-align: left;
  min-width: 130px;
}
.color_recommend {
  color: #8bc34a;
}
.color_alert {
  color: #f44336;
}
</style>
